import { Fragment } from "react";
import HiringSection from "../../components/Hiring/HiringSection";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import MailIcon from "@mui/icons-material/Mail";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocationPinIcon from "@mui/icons-material/LocationPin";
import SmsIcon from "@mui/icons-material/Sms";
import "./ContactPage.css";

const ContactPage = () => {
  return (
    <Fragment>
      <BreadCrumb title={"Contact Us"} currentpageTitle={"Contact Us"} />
      <section className="contactpage-style">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-12 col-md-12 location-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.069211003627!2d80.1646995!3d12.9226721!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9f8bd89bdca64146!2sKairaa%20Techserve!5e0!3m2!1sen!2sin!4v1669376896234!5m2!1sen!2sin"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="message-icon">
                <SmsIcon/>
              </div>
              <h3>Let's Connect</h3>
              <p>
                We're here to discuss your vision and explore how we can bring
                it to life together.
              </p>
              <div className="contact-data d-flex align-items-center">
                <div className="text-white">
                  <i>
                    <MailIcon />
                  </i>
                </div>
                <div>
                  <h6 className="text-uppercase">email us</h6>
                  <p>support@kairaatechserve.com</p>
                </div>
              </div>
              <div className="contact-data d-flex align-items-center">
                <div className="text-white">
                  <i>
                    <PhoneInTalkIcon />
                  </i>
                </div>
                <div>
                  <h6 className="text-uppercase">call us</h6>
                  <p>7092770303</p>
                </div>
              </div>
              <div className="contact-data d-flex align-items-center">
                <div className="text-white">
                  <i>
                    <LocationPinIcon />
                  </i>
                </div>
                <div>
                  <h6 className="text-uppercase">visit us</h6>
                  <p>Eswari Nagar, Gowrivakkam, Chennai - 600073.</p>
                </div>
              </div>
            </div>
            <div className="contact-form col-lg-6 col-md-6">
              <h1 className="mb-3">Send us a message</h1>
              <form>
                <div className="row">
                  <div class="col-lg-6 mb-3">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control" />
                  </div>
                  <div class="col-lg-6 mb-3">
                    <label class="form-label">Email id</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="mb-3">
                  <label class="form-label">Message</label>
                  <textarea class="form-control"></textarea>
                </div>
                <button type="submit" class="send-btn mt-4">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default ContactPage;
